import React, { useEffect, useState } from 'react';
import { LoginCallback } from '@okta/okta-react';

const OktaLoginCallback = () => {
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [showTimeout, setShowTimeout] = useState(false);

  useEffect(() => {
    // Track time elapsed for timeout handling
    const timer = setInterval(() => {
      setTimeElapsed((prev) => {
        const newTime = prev + 1;
        // Show timeout warning after 30 seconds
        if (newTime >= 30) {
          setShowTimeout(true);
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRetry = () => {
    // Clear URL parameters and redirect to login
    window.location.href = '/login';
  };

  const LoadingComponent = () => (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}
    >
      <div
        className="text-center"
        style={{ maxWidth: '400px', padding: '2rem' }}
      >
        <div
          className="spinner-border text-primary mb-3"
          role="status"
          style={{ width: '3rem', height: '3rem' }}
        >
          <span className="visually-hidden">Processing authentication...</span>
        </div>

        <h5 className="mb-3">Completing Authentication...</h5>
        <p className="text-muted mb-3">
          Please wait while we process your login.
        </p>

        {showTimeout && (
          <div className="alert alert-warning mt-3">
            <p className="mb-2">
              <strong>Taking longer than expected?</strong>
            </p>
            <p className="mb-3" style={{ fontSize: '0.9rem' }}>
              The authentication process is taking longer than usual. This might
              be due to network issues or server delays.
            </p>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={handleRetry}
            >
              Try Again
            </button>
          </div>
        )}

        <div className="mt-3" style={{ fontSize: '0.8rem', color: '#666' }}>
          Time elapsed: {timeElapsed}s
        </div>
      </div>
    </div>
  );

  const ErrorComponent = ({ error }) => (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}
    >
      <div
        className="text-center"
        style={{ maxWidth: '500px', padding: '2rem' }}
      >
        <div className="alert alert-danger">
          <div className="mb-3">
            <i
              className="bi bi-exclamation-triangle"
              style={{ fontSize: '2rem', color: '#dc3545' }}
            ></i>
          </div>

          <h4 className="alert-heading">Authentication Error</h4>
          <p className="mb-3">
            An error occurred during the authentication process.
          </p>

          <hr />

          <div className="mb-3">
            <strong>Error Details:</strong>
            <div
              className="mt-2 p-2"
              style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                fontSize: '0.9rem',
              }}
            >
              {error?.message || 'Unknown authentication error'}
            </div>
          </div>

          {error?.errorCode && (
            <div className="mb-3">
              <strong>Error Code:</strong> {error.errorCode}
            </div>
          )}

          <div className="d-flex gap-2 justify-content-center">
            <button className="btn btn-primary" onClick={handleRetry}>
              Try Again
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => (window.location.href = '/')}
            >
              Back to Home
            </button>
          </div>
        </div>

        <div className="mt-3">
          <p style={{ fontSize: '0.85rem', color: '#666' }}>
            If this problem persists, please contact your system administrator.
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <LoginCallback
      loadingElement={<LoadingComponent />}
      errorComponent={ErrorComponent}
    />
  );
};

export default OktaLoginCallback;
